import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '../../components/PageHeader/PageHeader';
import MetricRow from '../../components/MetricRow/MetricRow';
import MetricCard from '../../components/MetricCard/MetricCard';
import FilterTabs from '../../components/FilterTabs/FilterTabs';
import Badge from '../../components/Badge/Badge';
import Button from '../../components/Button/Button';
import styles from './Participants.module.css';

const Participants = () => {
  const [activeTab, setActiveTab] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');

  const tabs = [
    { id: 'all', label: 'All', count: '12,480' },
    { id: 'verified', label: 'Verified', count: '8,960' },
    { id: 'in_review', label: 'In review', count: 23 },
    { id: 'flagged', label: 'Flagged', count: 17 }
  ];

  const participantsData = [
    {
      id: 1,
      name: 'Aman Sharma',
      ageLocation: '22 · Delhi',
      verification: 'Verified',
      studies: 4,
      earned: '₹14,300',
      trustScore: 96,
      status: 'Active'
    },
    {
      id: 2,
      name: 'Riya Kapoor',
      ageLocation: '20 · Mumbai',
      verification: 'Verified',
      studies: 2,
      earned: '₹6,000',
      trustScore: 91,
      status: 'Active'
    },
    {
      id: 3,
      name: 'Kabir Mehta',
      ageLocation: '24 · Delhi',
      verification: 'In review',
      studies: 0,
      earned: '₹0',
      trustScore: '—',
      status: 'Active'
    },
    {
      id: 4,
      name: 'Rohit Jain',
      ageLocation: '27 · Gurugram',
      verification: 'Rejected',
      studies: 1,
      earned: '₹600',
      trustScore: 38,
      status: 'Flagged'
    },
    {
      id: 5,
      name: 'Pooja Rawat',
      ageLocation: '34 · Delhi',
      verification: 'Verified',
      studies: 6,
      earned: '₹7,750',
      trustScore: 98,
      status: 'Active'
    },
    {
      id: 6,
      name: 'Vivek Nair',
      ageLocation: '23 · Delhi',
      verification: 'Verified',
      studies: 3,
      earned: '₹11,000',
      trustScore: 88,
      status: 'Active'
    }
  ];

  const filteredParticipants = participantsData.filter((item) => {
    const matchesSearch =
      item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.ageLocation.toLowerCase().includes(searchTerm.toLowerCase());
    if (activeTab === 'verified') return matchesSearch && item.verification === 'Verified';
    if (activeTab === 'in_review') return matchesSearch && item.verification === 'In review';
    if (activeTab === 'flagged') return matchesSearch && item.status === 'Flagged';
    return matchesSearch;
  });

  const headerActions = (
    <>
      <input
        type="text"
        placeholder="Search participants..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className={styles.searchInput}
      />
      <Button
        variant="secondary"
        onClick={() => alert('Participants list exported.')}
      >
        Export
      </Button>
    </>
  );

  return (
    <>
      <PageHeader
        title="Participants"
        subtitle="Everyone who has signed up on the Nopser app."
        actions={headerActions}
      />

      <MetricRow columns={4}>
        <MetricCard label="Signed up" value="12,480" subtext="+640 this month" />
        <MetricCard label="Verified" value="8,960" subtext="72%" />
        <MetricCard label="Active in 30 days" value="3,410" subtext="applied or attended" />
        <MetricCard label="Avg. trust score" value="87" subtext="out of 100" />
      </MetricRow>

      <div style={{ marginTop: '20px' }}>
        <FilterTabs
          tabs={tabs}
          activeTab={activeTab}
          onTabChange={setActiveTab}
        />
      </div>

      <section className={styles.tableCard}>
        <div className={styles.tableHeader}>
          <div>Participant</div>
          <div>Verification</div>
          <div>Studies</div>
          <div>Earned</div>
          <div>Trust score</div>
          <div>Status</div>
          <div></div>
        </div>

        {filteredParticipants.map((item) => (
          <div key={item.id} className={styles.tableRow}>
            <div>
              <div className={styles.participantInfo}>
                <span className={styles.participantName}>{item.name}</span>
                <span className={styles.participantMeta}>{item.ageLocation}</span>
              </div>
            </div>

            <div>
              <Badge
                variant={
                  item.verification === 'Verified'
                    ? 'success'
                    : item.verification === 'In review'
                    ? 'blue'
                    : 'danger'
                }
              >
                {item.verification}
              </Badge>
            </div>

            <div className={styles.cellText}>{item.studies}</div>
            <div className={styles.earnedText}>{item.earned}</div>
            <div className={styles.cellText}>{item.trustScore}</div>

            <div>
              <Badge variant={item.status === 'Active' ? 'success' : 'danger'}>
                {item.status}
              </Badge>
            </div>

            <div>
              <Link to="/participant-profile" className={styles.viewLink}>
                View →
              </Link>
            </div>
          </div>
        ))}
      </section>
    </>
  );
};

export default Participants;
